import React, { Component } from 'react';
import apiRequests from './api-helpers/ApiRequests';
import { Container } from 'react-bootstrap';
import AddDictionaryItemCars from './AddDictionaryItemCars';
import EditDictionaryItemCars from './EditDictionaryItemCars';
import update from 'react-addons-update';
import { useSelector } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

class Cars extends Component {
    constructor(props) {
        super(props);

        this.state = {
            report: {},
            isLoaded: false,
            pageSize: 15,
            currentPageNum: 1,
            totalPagesCount: 1,
            modalAddItemFormIsVisible: false,
            modalEditItemFormIsVisible: false,
            searchParams: [],
            selectedItem: null,
            showDeleteModal: false,
        };

        this.loadCarsList = this.loadCarsList.bind(this);
        this.loadCarsListCallback = this.loadCarsListCallback.bind(this);
        this.prevPage = this.prevPage.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.onClickAddNewItem = this.onClickAddNewItem.bind(this);
        this.onClickEditItem = this.onClickEditItem.bind(this);
        this.onChangeAddItemFormVisibility = this.onChangeAddItemFormVisibility.bind(this);
        this.onChangeEditItemFormVisibility = this.onChangeEditItemFormVisibility.bind(this);
        this.addNewItemCallback = this.addNewItemCallback.bind(this);
        this.searchItems = this.searchItems.bind(this);
        this.selectCar = this.selectCar.bind(this);
        this.handleDeleteModal = this.handleDeleteModal.bind(this);
        this.removeCar = this.removeCar.bind(this);
    }

    componentDidMount() {
        this.loadCarsList();
    }

    loadCarsList(page) {
        const setPageNum = page || this.state.currentPageNum;

        const params = {
            DataInHttpResponse: true,
            SearchParams: [
                ...this.state.searchParams,
                { Name: "page", Value: setPageNum + "" },
                { Name: "size", Value: this.state.pageSize + "" },
                { Name: "ExtCompanyId", Value: this.props.userData.CompanyWorkflowId + "X" },
            ],
            ReportID: this.props.t('raportIds.vehicles'),
        };

        apiRequests.getDataByUrlWithParam('webconapi/GetWebconReport', params, this.loadCarsListCallback);
    }

    loadCarsListCallback(data) {
        const pagesCount = Math.floor(data.count / this.state.pageSize) + 1;

        this.setState({
            report: data,
            isLoaded: true,
            totalPagesCount: pagesCount,
            currentPageNum: data.page,
        });
    }

    prevPage() {
        if (this.state.currentPageNum > 1) {
            this.setState({ isLoaded: false }, () => {
                this.loadCarsList(this.state.currentPageNum - 1);
            });
        }
    }

    nextPage() {
        if (this.state.currentPageNum < this.state.totalPagesCount) {
            this.setState({ isLoaded: false }, () => {
                this.loadCarsList(this.state.currentPageNum + 1);
            });
        }
    }

    onClickAddNewItem() {
        this.onChangeAddItemFormVisibility(true);
    }

    onClickEditItem() {
        if (this.state.selectedItem) {
            this.onChangeEditItemFormVisibility(true);
        }
    }

    onChangeAddItemFormVisibility(value) {
        this.setState({ modalAddItemFormIsVisible: value });
    }

    onChangeEditItemFormVisibility(value) {
        this.setState({ modalEditItemFormIsVisible: value });
    }

    addNewItemCallback() {
        this.loadCarsList(1);
    }

    searchItems(event) {
        const searchParam = { Name: event.target.name, Value: event.target.value };

        this.setState(
            (prevState) => {
                const idx = prevState.searchParams.findIndex((obj) => obj.Name === searchParam.Name);

                if (idx === -1) {
                    return { searchParams: [...prevState.searchParams, searchParam] };
                } else {
                    return { searchParams: update(prevState.searchParams, { [idx]: { $set: searchParam } }) };
                }
            },
            () => {
                this.loadCarsList(1);
            }
        );
    }

    selectCar(row) {
        this.setState((prevState) => ({
            selectedItem: prevState.selectedItem?.id === row.id ? null : row,
        }));
    }

    handleDeleteModal(show) {
        this.setState({ showDeleteModal: show });
    }

    removeCar() {
        if (this.state.selectedItem) {
            const deleteParams = {
                CarId: parseInt(this.state.selectedItem.id),
                RegistationNumber: "test",
                CompanyWorkflowId: String(this.props.userData.CompanyWorkflowId),
            };

            apiRequests.getDataByUrlWithParam(
                'WebconAPI/DeleteCarsDictionaryItem',
                deleteParams,
                (data) => {
                    if (data.Message === "0") {
                        this.setState(
                            { isLoaded: false, selectedItem: null, showDeleteModal: false },
                            () => this.loadCarsList(this.state.currentPageNum)
                        );
                    } else {
                        console.error('Deletion failed:', data);
                    }
                }
            );
        }
    }

    render() {
        const { report, selectedItem } = this.state;

        const content = !this.state.isLoaded ? (
            <Container className="m-0 p-0">
                <div className="row h-100 m-auto justify-content-center">
                    <div className="spinner-border text-primary align-self-center" role="status"></div>
                </div>
            </Container>
        ) : (
            <>
                <AddDictionaryItemCars
                    show={this.state.modalAddItemFormIsVisible}
                    onChangeAddItemFormVisibilityHandler={this.onChangeAddItemFormVisibility}
                    addNewEventNotificationCallback={this.addNewItemCallback}
                    userData={this.props.userData}
                />
                <EditDictionaryItemCars
                    show={this.state.modalEditItemFormIsVisible}
                    onChangeEditItemFormVisibilityHandler={this.onChangeEditItemFormVisibility}
                    editEventNotificationCallback={this.addNewItemCallback}
                    userData={this.props.userData}
                    editedItem={this.state.selectedItem}
                />
                <table className="table custom-table-font">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            {report.columns.map((column) => (
                                <th key={column.guid} scope="col" className={column.name === "ID" ? "d-none" : ""}>
                                    {column.name}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        <tr key="-1">
                            <th scope="row">
                                <i className="bi bi-search"></i>
                            </th>
                            {report.columns.map((column) => {
                                const searchVal = this.state.searchParams.find(x => x.Name === column.name);
                                return (
                                    <td key={column.guid || "col" + column.name} className={column.name === "ID" ? "d-none" : ""}>
                                        <input
                                            type="text"
                                            className="form-control fs-7"
                                            name={column.name}
                                            placeholder={column.name}
                                            onChange={this.searchItems}
                                            value={searchVal ? searchVal.Value : ""}
                                        />
                                    </td>
                                );
                            })}
                        </tr>
                        {report.rows.map((row, i) => (
                            <tr
                                key={row.id}
                                onClick={() => this.selectCar(row)}
                                className={selectedItem?.id === row.id ? "table-active" : ""}
                            >
                                <th scope="row">{((this.state.currentPageNum - 1) * this.state.pageSize) + i + 1}</th>
                                {row.cells.map((cell, j) => (
                                    <td key={j} className={j === 0 ? "d-none" : ""}>
                                        {Array.isArray(cell.value) ? cell.value[0].name : cell.value}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </>
        );

        return (
            <Container className="px-0 pt-0" fluid>
                <div className="tables-nav">
                    <nav aria-label="Page navigation">
                        <ul className="pagination">
                            <li className="page-item">
                                <a className="btn btn-outline-dark" onClick={this.prevPage}>
                                    <span aria-hidden="true">«</span>
                                </a>
                            </li>
                            <li className="page-item">
                                <span className="btn btn-outline-dark mx-1 font-weight-600">{this.state.currentPageNum}</span>
                            </li>
                            <li className="page-item">
                                <a className="btn btn-outline-dark" onClick={this.nextPage}>
                                    <span aria-hidden="true">»</span>
                                </a>
                            </li>
                        </ul>
                    </nav>
                    <button className="btn btn-outline-dark mx-1" onClick={this.onClickAddNewItem}>
                        <i className="bi bi-plus-circle me-2"></i>{this.props.t('common.add')}
                    </button>
                    <button
                        className="btn btn-outline-dark mx-1"
                        onClick={this.onClickEditItem}
                        disabled={!selectedItem}
                    >
                        <i className="bi bi-pencil-square me-2"></i>{this.props.t('common.edit')}
                    </button>
                    <button
                        className="btn btn-outline-dark mx-1"
                        onClick={() => this.handleDeleteModal(true)}
                        disabled={!selectedItem}
                    >
                        <i className="bi bi-x-circle me-2"></i>{this.props.t('common.remove')}
                    </button>
                </div>

                <div className="m-0 p-0">{content}</div>

                <Modal show={this.state.showDeleteModal} onHide={() => this.handleDeleteModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.props.t('cars.modalRemoveTitle')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.props.t('cars.modalRemoveQuestion')} (
                        {this.state.selectedItem?.cells[2].value || 'N/A'})
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.handleDeleteModal(false)}>
                            {this.props.t('common.cancel')}
                        </Button>
                        <Button variant="danger" onClick={this.removeCar}>
                            {this.props.t('common.remove')}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Container>
        );
    }
}

function withMyHook(Component) {
    return function WrappedComponent(props) {
        const userData = useSelector((state) => state.currentUser.userData);
        const { t } = useTranslation();
        return <Component {...props} userData={userData} t={t} />;
    };
}

export default withMyHook(Cars);
